export function msToSec(value: number): number {
    return Math.floor(value / 1000)
}

export function diffHours(d1: Date, d2: Date): number {
    const diff = (d1.getTime() - d2.getTime()) / 1000
    return Math.abs(Math.round(diff / (60 * 60)))
}

export function timestampToHours(value: number): number {
    return Math.abs(Math.round(value / 1000 / (60 * 60)))
}
